import React from "react";
import {useCurrentUser} from "../../../utils/CurrentUserContext";
import {useState} from "react";
import dayjs from "dayjs";
import Spinner from "../../../components/icons/Spinner";
import { useCubeQuery } from "../../../utils/hooks/useCubeQuery";
import useCubeClient from "../../../utils/cubejs-client";
import DateSelect from "../../../components/buttons/DateSelect";
import {useDateRange} from "../../../utils/date-utils";
import Table from "../../../components/lists/Table/Table";

const AccountReporting = () => {
    const {user} = useCurrentUser();
    const cubejsApi = useCubeClient();
    
    // Using the enhanced useDateRange hook with 300ms debounce
    const {
      dateRange,
      handleDateChange: handleDate,
      formattedDateRange
    } = useDateRange(
      [dayjs().add(-730, "d"), dayjs()], // Default to last 2 years
      300 // 300ms debounce
    );

    const columns = [
        {
        title: "Campaign Name",
        dataIndex: "campaignName",
        key: "campaignName",
        sorter: (a, b) => {
          if (a.campaignName && b.campaignName) {
            return a.campaignName.localeCompare(b.campaignName);
          }
          // Handle null or undefined campaignName values
          if (!a.campaignName) return 1;
          if (!b.campaignName) return -1;
          return 0;
        }
      },
      {
        title: "Websites",
        dataIndex: "concatenatedWebsites",
        key: "concatenatedWebsites",
      },
      {
        title: "eCPM",
        dataIndex: "eCpm",
        key: "eCPM",
        sorter: (a, b) => a.eCpm - b.eCpm,
      },
      {
        title: "Revenue",
        dataIndex: "publisherRevenue",
        key: "publisherRevenue",
        sorter: (a, b) => a.publisherRevenue
          - b.publisherRevenue
        ,
      },
      {
        title: "Reads",
        dataIndex: "reads",
        key: "reads",
        sorter: (a, b) => a.reads - b.reads,
      },

    ]

    const {
      resultSet: campiData,
      error: campiError,
      isLoading: campiLoading,
    } = useCubeQuery(
      {
        dimensions: [
          "aggregateTdLevel.campaignName",
        ],
        measures: [
          "aggregateTdLevel.eCpm",
          "aggregateTdLevel.reads",
          "aggregateTdLevel.publisherRevenue",
          "aggregateTdLevel.concatenatedWebsites"
        ],
        timeDimensions: [
          {
            dimension: "aggregateTdLevel.date",
            dateRange: formattedDateRange,
          }],
        filters: [
          {
            "member": "aggregateTdLevel.websiteId",
            "operator": "set"
          },
          {
            "member": "aggregateTdLevel.publisherId",
            "operator": "set"
          },
          {
            "member": "aggregateTdLevel.fraud",
            "operator": "notEquals",
            "values": ["true"]
          }
        ]
      },
      {cubejsApi}
    );

    if (campiError || campiLoading || campiData == null) {
      return (<Spinner/>)
    }

  const updatedKeysData = campiData.loadResponses[0].data.map(item => {
    const newItem = {};
    Object.keys(item).forEach(key => {
      const newKey = key.replace('aggregateTdLevel.', '');

      // Handle rounding for specific keys
      if (newKey === 'eCpm' || newKey === 'publisherRevenue') {
        newItem[newKey] = item[key] ? parseFloat(item[key]).toFixed(2) : item[key];
      } else {
        newItem[newKey] = item[key];
      }
    });
    return newItem;
  });


    return (
      <div className="pb-4 bg-white rounded-lg shadow-lg py-2">
        <div className="px-2 sm:px-6 lg:px-4 py-4">
          <div className="sm:flex sm:items-center p-2">
            <div className="sm:flex-auto">
              <h1 className="text-lg leading-6 font-medium text-gray-900 pb-2">
                Revenue
              </h1>
              <DateSelect dateRange={dateRange} handleDate={handleDate}/>
            </div>
          </div>
          <Table columns={columns} data={updatedKeysData} searchable={false}/>
        </div>
      </div>
    );
  }
;

export default AccountReporting;
